export default __webpack_public_path__ + "resources/icons/n231-c2b9.png";